export const VerifiedStudentsType = {
    FETCH_VERIFIED_STUDENT_START: 'FETCH_VERIFIED_STUDENT_START',
    FETCH_VERIFIED_STUDENT_SUCCESS: 'FETCH_VERIFIED_STUDENT_SUCCESS',
    FETCH_VERIFIED_STUDENT_FAILURE: 'FETCH_VERIFIED_STUDENT_FAILURE'
}